// get-field-from-entity.ts
import { Change, nothingHere } from "@adornis/base/change.js";
import { logger } from "@adornis/base/logging.js";
import { isGQLScalarType } from "@adornis/baseql/baseqlTypes.js";
import { nothing } from "lit";
var getFieldFromEntity = (entityInstance, columnDefinition) => {
  let retrievedField;
  try {
    if (columnDefinition.getFieldMapping)
      retrievedField = columnDefinition.getFieldMapping(entityInstance) ?? "";
    if (retrievedField === void 0 && !!columnDefinition.fieldName)
      retrievedField = hasArrayFieldInFieldName(entityInstance, columnDefinition.fieldName) ? resolvePathWithArray(entityInstance, columnDefinition.fieldName) : Change.resolvePath(entityInstance, columnDefinition.fieldName.split("."));
    if (retrievedField === nothingHere)
      retrievedField = "";
    else if (typeof retrievedField === "symbol" && retrievedField !== nothing)
      retrievedField = retrievedField.toString();
    if (retrievedField === void 0)
      throw new Error("All options exhausted.");
    if (retrievedField === null)
      retrievedField = "";
  } catch (e) {
    logger.error(
      { err: e },
      `Could not resolve field '${JSON.stringify(columnDefinition)}' with getFieldMapping or fieldName on ${entityInstance._class}`
    );
    throw e;
  }
  return retrievedField;
};
var hasArrayFieldInFieldName = (entityInstance, fieldName) => {
  if (!fieldName)
    return false;
  const fieldArray = fieldName.split(".");
  const fieldKey = fieldArray[0];
  const fieldDefinition = entityInstance.constructor.fields[fieldKey];
  if (!fieldDefinition)
    return false;
  if (fieldDefinition.arrayDepth() > 0)
    return true;
  const newValue = entityInstance[fieldKey];
  if (!newValue?.constructor)
    return false;
  return hasArrayFieldInFieldName(newValue, fieldArray.slice(1).join("."));
};
var resolvePathWithArray = (entityInstance, fieldName, joinDelimiter = ", ") => {
  if (!fieldName)
    return [entityInstance];
  const fieldArray = fieldName.split(".");
  const fieldKey = fieldArray[0];
  const fieldDefinition = entityInstance?.constructor?.fields[fieldKey];
  if (!fieldDefinition || !entityInstance)
    return [];
  if (fieldDefinition.arrayDepth() > 0) {
    if (isGQLScalarType(fieldDefinition.type))
      return entityInstance[fieldKey]?.filter(Boolean).join(joinDelimiter) ?? nothingHere;
    else
      return entityInstance[fieldKey]?.map((entry) => resolvePathWithArray(entry, fieldArray.slice(1).join("."))).filter((v) => !!v && v !== nothingHere) ?? nothingHere;
  } else {
    if (isGQLScalarType(fieldDefinition.type))
      return entityInstance[fieldKey] ?? nothingHere;
    else
      return resolvePathWithArray(entityInstance[fieldKey], fieldArray.slice(1).join("."));
  }
};
export {
  getFieldFromEntity
};
